import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { TokenService } from '../../auth/services/token.service';

@Injectable()
export class AuthorisedBlobService {

  constructor(
    private http: HttpClient,
    private tokenService: TokenService) {
  }

  get(url: string): Observable<any> {
    return new Observable((observer: Subscriber<any>) => {
      let objectUrl: string = null;

      this.fetchBlob(url).subscribe({
        next: blob => {
          objectUrl = URL.createObjectURL(blob);
          observer.next(objectUrl);
        },
        error: e => {
          observer.next(false);
        }});

      return () => {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
          objectUrl = null;
        }
      };
    });
  }

  getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();

    let token = this.tokenService.getToken();
    if (token) {
      headers.set('Authorization', 'Bearer ' + token);
    }
    return headers;
  }

  fetchBlob(url: string): Observable<any> {
    return this.http.get(url, {
      headers: this.getHeaders(),
      responseType: 'blob'
    });
  }
}
